<template>
  <u-avatar
    icon="i-heroicons-user-circle-16-solid"
    :src="person.avatarImage"
    :ui="uiConfig"
    :img-class="imgClass"
  />
</template>

<script setup>
  const props = defineProps({
    person: Object,
    ui: Object,
    hoverZoom: Boolean
  });

  const uiConfigBase = {
    background: 'bg-shell dark:bg-shell-700',
    icon: {base: 'text-shell-100 dark:text-shell-200 !h-full !w-full'}
  };

  const uiConfig = Object.assign(uiConfigBase, props.ui);
  const imgClass = computed(() => {
    return props.hoverZoom
      ? 'object-cover transition duration-300 group-hover:scale-[1.03]'
      : 'object-cover';
  });
</script>
